// Activates a question on its tool owner without copying question text from
// this command-only event.
import { z } from 'zod';

import { defineCompoundMember } from '@apps/web/features/phoebe_chat_v3/registry/types';

const userQuestionRequiredPayloadSchema = z
    .object({ command_id: z.uuid() })
    .strip();

export const userQuestionRequiredDefinitions = {
    user_question_required: defineCompoundMember('user_question_required', {
        disposition: 'compound_member',
        schema: userQuestionRequiredPayloadSchema,
        malformed: { kind: 'skip' },
        evidence: null,
        slotMember: {
            slot: 'question',
            terminal: false,
            keys(payload, occurrence) {
                const causedByEventId =
                    occurrence.committed?.caused_by_event_id;
                if (causedByEventId === null || causedByEventId === undefined) {
                    return [
                        {
                            kind: 'command_id',
                            value: payload.command_id,
                        },
                    ];
                }
                // The event key attaches this member; the command key is
                // retained as the alias used by its resolution event.
                return [
                    { kind: 'event_id', value: causedByEventId },
                    {
                        kind: 'command_id',
                        value: payload.command_id,
                    },
                ];
            },
            fragment(payload) {
                return {
                    kind: 'question_required',
                    commandId: payload.command_id,
                };
            },
        },
    }),
} as const;

export const userQuestionRequiredContractFixtures = {
    valid: { command_id: '0198a846-739e-7a2f-a152-66a77cc11111' },
    malformed: { command_id: 'not-a-uuid' },
} as const;
